import { MUTATIONS, useMutation } from "../../../../../api";
import ReactionButton from "../../../../../design-system/components/ReactionButton/ReactionButton.jsx";
import { pluralize } from "../../../../../lib/text-utils.js";
import * as styles from "./ReactionBar.css.ts";

const reactions = ["✨", "🌱", "🆒", "❤️", "🐙"];

const reactionLabels = {
  "✨": "Sparks",
  "🌱": "Pflanze",
  "🆒": "Cool",
  "❤️": "Herz",
  "🐙": "Oktopus",
};

export const ReactionBar = ({ entry, myReaction, sparkId }) => {
  const [doAdd] = useMutation(MUTATIONS.addReaction);
  const [doRemove] = useMutation(MUTATIONS.removeReaction);
  const onAddReaction = (reaction) => {
    doAdd({
      reaction,
      workshopId: entry.workshopId,
      entryId: entry.id,
      smallTeamId: entry.smallTeamId,
      sparkId,
    });
  };
  const onRemoveReaction = (reaction) => {
    doRemove({
      reaction,
      workshopId: entry.workshopId,
      entryId: entry.id,
      smallTeamId: entry.smallTeamId,
      sparkId,
    });
  };

  return (
    <div className={styles.root}>
      <ul className={styles.reactionsList}>
        {reactions.map((r) => {
          const count = entry.reactionCounts[r] || 0;
          const isActive = myReaction === r;
          const label = `${reactionLabels[r]} (${count})`;

          return (
            <li key={r}>
              <ReactionButton
                reaction={r}
                active={isActive}
                count={count}
                aria-label={label}
                aria-pressed={isActive}
                onClick={(e) => {
                  e.stopPropagation();
                  return isActive ? onRemoveReaction(r) : onAddReaction(r);
                }}
              />
            </li>
          );
        })}
      </ul>
      <div className={styles.visitCount} aria-live="polite">
        {pluralize(entry.visitCounts, "Besuch", "Besuche")}
      </div>
    </div>
  );
};
